import React from 'react';
import { View, Text, StyleSheet, ActivityIndicator, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';

const LoadingScreen = () => {
  const { palette, mode } = useTheme();

  return (
    <View 
      style={[
        styles.container,
      ]}
    >
      <View style={styles.content}>
        <ActivityIndicator 
          size="large" 
          color={palette.primary} 
          style={styles.spinner}
        />
        <Text style={[styles.text, { color: palette.text }]}>
          Loading...
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    ...Platform.select({
      web: {
        minHeight: '100vh',
        minWidth: '100vw',
      },
    }),
  },
  content: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
  },
  spinner: {
    marginBottom: 8,
  },
  text: {
    fontSize: 16,
    fontFamily: 'Archivo',
    fontWeight: '500',
    opacity: 0.7,
  },
});

export default LoadingScreen;

